
export const ACCESSTYPES: any = {
  ReadOnly: -9968,
  AddEdit: -9967,
  AddEditDelete: -9966,
  Show: -9965,
  Hide: -9964
};
